import React, { useEffect } from 'react'
import { Link, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { confirmRegistration } from '../actions/userActions'
import ReactGA from 'react-ga4';
import SEO from '../components/SEO';

function ConfirmRegistrationScreen() {

    ReactGA.send({ hitType: "pageview", page: window.location.pathname });

    const { id } = useParams()

    const dispatch = useDispatch()

    const confirmRegistrationState = useSelector(state => state.userConfirmRegistration)
    const { confirming, error } = confirmRegistrationState

    useEffect(() => {
        dispatch(confirmRegistration(id))
    }, [dispatch])

    return (
        <>
            <SEO 
                title="Confirm Registration - PCRAssist"
                description="Complete your PCRAssist account registration. Verify your email to activate your account and access all features."
                canonicalUrl="/confirm"
            />
            <div>
                {
                    confirming ? <Loader/>:
                    error ?
                    <div>
                        <Message variant='danger'>{error}</Message>
                        Please register again.
                    </div>
                    :
                    <div>
                        <h1>Registration complete</h1>
                        Please continue to login by clicking&nbsp;
                        <Link to='/login'>
                            here
                        </Link>.
                    </div>
                }
            </div>
        </>
    ) 
}

export default ConfirmRegistrationScreen
